import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormMessage, Input, Label } from '@@/ui/primitives';

export function NumberConstraints() {
  const form = useFormContext();

  return (
    <div className='flex flex-col gap-6 p-4'>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-semibold text-neutral-950'>Number constraints</h4>
        <p className='text-xs text-neutral-600'>Set the minimum and maximum value for the number.</p>
      </div>
      <div className='flex items-start gap-4'>
        <FormField
          control={form.control}
          name='definition.minimum'
          render={({ field }) => (
            <FormItem className='flex flex-col gap-2'>
              <Label htmlFor='min-value'>Minimum Value</Label>
              <Input
                id='min-value'
                type='number'
                {...field}
                value={field.value ?? ''}
                onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : 0)}
                placeholder='No minimum'
                className='text-sm! bg-white shadow-none'
              />
              <FormMessage className='text-sm text-red-600' />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name='definition.maximum'
          render={({ field }) => (
            <FormItem className='flex flex-col gap-2'>
              <Label htmlFor='max-value'>Maximum Value</Label>
              <Input
                id='max-value'
                type='number'
                {...field}
                value={field.value ?? ''}
                onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : 100)}
                placeholder='No maximum'
                className='text-sm! bg-white shadow-none'
              />
              <FormMessage className='text-sm text-red-600' />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
